import { liveLocales } from "@/i18n/apps"

/** Locales whose hreflang key differs from the URL locale segment. */
export const HREFLANG_KEY_OVERRIDES: Record<string, string> = {
    "ja-jp": "ja"
}

/** The hreflang key a locale segment is published under (`ja-jp` → `ja`). */
export const hreflangKeyForLocale = (locale: string): string =>
    HREFLANG_KEY_OVERRIDES[locale] ?? locale

/**
 * Every hreflang key the site publishes: one per live locale in `i18n/apps.ts`, plus
 * `x-default`. Derived rather than listed, so adding or activating a locale through the
 * application scripts is enough; a preview locale is never advertised.
 */
export const HrefLangs: readonly string[] = [
    ...liveLocales.map(hreflangKeyForLocale),
    "x-default"
]

export type HreflangKeys = string

export type HreflangMap = Record<HreflangKeys, string>
